import * as React from "react";
import { useCartBadge } from "@features/cart/shopping-cart-store";
import { useBottomTabBadges } from "react-native-ridge-navigation";
import { BottomRoots } from "../../Navigator";

function CartBadgeUpdater() {
  const totalAmount = useCartBadge();
  const { updateBadge } = useBottomTabBadges();
  React.useEffect(() => {
    updateBadge(BottomRoots.Cart, totalAmount > 0 ? `${totalAmount}` : null);
  }, [totalAmount]);
  return null as any;
}

export default CartBadgeUpdater;
